// extracted by mini-css-extract-plugin
export default {"div1":"orders_div1__ToYOr","p1":"orders_p1__xNVm+","div2":"orders_div2__fYPxu","alert":"orders_alert__eq5Rd","loader":"orders_loader__YnCJw"};